import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import Edit from "./edit";
import example from "./example";
import icons from "../../util/RTCLGB-icon-controls/icons"

registerBlockType("rtcl/listing-cat-box-slider", {
	title: __("Listing Category Slider", "classified-listing"),
	description: __("clasified listing category Slider box", "classified-listing"),
	category: "classified-list-gb",
	icon: {
		src: icons.rtclLogo,
	},
	keywords: [
		__("category slider", "classified-listing"),
		__("category-box", "classified-listing"),
		__("classified-listing", "classified-listing"),
	],
	//attributes,
	getEditWrapperProps({ align }) {
		if (
			'left' === align ||
			'right' === align ||
			'full' === align ||
			'wide' === align
		) {
			return { 'data-align': align };
		}
	},

	edit: Edit,
	save: () => null,
	//example,
});